export default {
  methods: {
    navIsActive(name) {
      const { name: routeName } = this.$route;
      return name === routeName;
    },
  },
};
